/* unplugin-vue-components disabled */import { render } from "./Tm-icon.vue?vue&type=template&id=a055c19a"
import script from "./Tm-icon.vue?vue&type=script&lang=js"
export * from "./Tm-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__